<app-memsafe-img class="image-thumbnail" *ngIf="imageSrc" [src]="imageSrc"></app-memsafe-img>
<app-icon *ngIf="comment || hasMetaComment" class="image-thumbnail__icon text-white" iconName="comment-filled"></app-icon>
